/**
 * DeepReasonsCard — 3 preguntas humanas del Advisor:
 *   1. ¿Por qué es tu mejor opción?
 *   2. ¿En qué tendrás que ceder?
 *   3. ¿Cuál es tu siguiente paso recomendado?
 *
 * Se muestra en la tarjeta top del guided flow y en Mi Decisión.
 */
import React from 'react';
import { CheckCircle2, AlertTriangle, ArrowRightCircle } from 'lucide-react';

const ITEMS = [
  {
    key: 'why_best',
    Icon: CheckCircle2,
    title: '¿Por qué es tu mejor opción?',
    accent: '#0e7c62',
    testId: 'deep-why-best',
  },
  {
    key: 'tradeoff',
    Icon: AlertTriangle,
    title: '¿En qué tendrás que ceder?',
    accent: '#f59e0b',
    testId: 'deep-tradeoff',
  },
  {
    key: 'next_step',
    Icon: ArrowRightCircle,
    title: '¿Cuál es tu siguiente paso?',
    accent: '#3b82f6',
    testId: 'deep-next-step',
  },
];

export default function DeepReasonsCard({ reasons, className = '' }) {
  if (!reasons) return null;
  return (
    <div className={`space-y-3 ${className}`} data-testid="deep-reasons-card">
      {ITEMS.map(({ key, Icon, title, accent, testId }) => {
        const text = reasons[key];
        if (!text) return null;
        return (
          <div
            key={key}
            className="rounded-xl border border-gray-100 bg-white p-3 flex gap-3"
            data-testid={testId}
          >
            <div
              className="w-8 h-8 rounded-full flex items-center justify-center shrink-0"
              style={{ background: `${accent}15`, color: accent }}
            >
              <Icon className="w-4 h-4" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[11px] uppercase tracking-widest font-semibold text-gray-500">
                {title}
              </p>
              <p className="text-sm text-habita-dark leading-relaxed mt-0.5">{text}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
